<div class="my-6 flex flex-col gap-2 rounded-xl border-2 border-neutral-100 bg-neutral-50 px-6 py-4 shadow-md hover:shadow-xl">
  <div class="flex items-center justify-between">
    <div class="flex w-2/5 flex-col gap-2">
      <span class="text-neutral-300">Тип і назва пакету</span>
      <div class="flex items-center gap-1">
        <h4>{{ insurancePackage().name }}</h4>
        <shared-info-badge
          [text]="insurancePackage().clientType === clientTypes.B2B ? 'B2B' : 'B2C'"
          [color]="colors.Blue"
          [withBorder]="true"
        ></shared-info-badge>
        @if (insurancePackage().type === packageTypes.AddOn) {
          <shared-info-badge
            [text]="insurancePackage().type"
            [color]="colors.Green"
            [withBorder]="true"
          ></shared-info-badge>
        }
      </div>
      @if (!!insurancePackage().description) {
        <span>{{ insurancePackage().description }}</span>
      }
    </div>
    <div class="flex w-1/5 flex-col gap-2">
      <span class="text-neutral-300">Термін дії</span>
      <span>
        {{ (insurancePackage().startDate | date: "dd.MM.yyyy") ?? "не вказано" }}
        - {{ (insurancePackage().endDate | date: "dd.MM.yyyy") ?? "не вказано" }}
      </span>
    </div>
    <div class="flex w-1/5 flex-col gap-2">
      <span class="text-neutral-300">Статус</span>
      <shared-status
        [statusValue]="insurancePackage().status"
        [statusMessage]="'statuses.package.' + insurancePackage().status | translate"
      ></shared-status>
    </div>
    <button
      class="btn flex items-center justify-center p-2 hover:bg-neutral-100"
      [type]="'button'"
      [matMenuTriggerFor]="insurancePackageActions"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu
      #insurancePackageActions="matMenu"
      xPosition="before"
    >
      @if (insurancePackage().status === packageStatus.Draft) {
        <button
          mat-menu-item
          (click)="activateInsurancePackage()"
        >
          <mat-icon class="text-primary-500 flex items-baseline justify-center"> toggle_on </mat-icon>
          {{ "Активувати" }}
        </button>
      }
      <button
        mat-menu-item
        (click)="editInsurancePackage()"
      >
        <mat-icon class="flex items-center justify-center">
          <img
            alt="View icon"
            width="20"
            height="20"
            [ngSrc]="'assets/icons/ic_edit.svg'"
          />
        </mat-icon>
        {{ "Редагувати" }}
      </button>
      <button
        mat-menu-item
        (click)="deleteEmptyPackage()"
      >
        <mat-icon class="flex items-center justify-center">
          <img
            alt="View icon"
            width="20"
            height="20"
            [ngSrc]="'assets/icons/ic_delete.svg'"
          />
        </mat-icon>
        {{ "Видалити" }}
      </button>
    </mat-menu>
  </div>
</div>
